import { Button } from '@components/styled/Button.styled';
import styled from 'styled-components';
import { SubmitGroup } from './SubmitGroup.styled';

export const RecalculateGroup = styled.div`
    display: flex;
    gap: 24px;
    flex-wrap: wrap;

    > ${SubmitGroup} {
        ${Button} {
            height: 40px;
        }
    }
    margin-bottom: 35px;
`;
